import React, { FC, useState, Fragment, useRef, useMemo, useEffect } from 'react'
import { IonContent } from '@ionic/react'
import { observer } from 'mobx-react'
import { orderMobx } from 'restaurant'
import { payMobx, themeMobx } from '@mobxStore'
import repositoryMobx from '@mobx/mall/repository.mobx'
import ordersController from 'controllers/ordersController'
import wxpayGoldPlanController from 'controllers/wxpayGoldPlanController'
import { Icon, ProductImage, GroupBuyStatus } from '@cps'
import { useHistoryNew, copyText, getPlatform } from '@utils'
import { ddayjs, format } from '@dt/fe-utils'
import { sumBy } from '@dt/fe-utils/dist/lodash'
import { DetailItem } from '../'
import { useMallRepositoryInit } from '@common/hooks'

import './index.scss'

interface IProps {
}

let initCnt = 0
let st: any = null

const reason = {
  'Success': 'result.orderSuccess',
  'Pending': 'result.resultPending',
  'Paying': 'result.resultPending',
  'Timeout': 'result.orderCancel',
  'Cancel': 'result.orderCancel'
}

const tips = {
  'Success': '',
  'Pending': '',
  'Paying': '',
  'Timeout': 'result.errorTips',
  'Cancel': 'result.errorTips'
}

const iconStatus = {
  'Success': 'icon-checkmark--outline',
  'Pending': 'icon-time2x',
  'Paying': 'icon-time2x',
  'Timeout': 'icon-dengdai',
  'Cancel': 'icon-dengdai'
}

const iconMakeStatus = {
  'waitsend': 'icon-Pedding',
  'sending': 'icon-Delivering',
  'signed': 'icon-Signed',
  'Returned': 'icon-Returned',
  'DiapatchError': 'icon-DiapatchError',
}

const { toPrice, toDate, toTime, toDateTime } = format

const Result: FC<IProps> = () => {
  const history = useHistoryNew()
  const [hasMap, setHasMap] = useState(false)
  const [context, setContext] = useState('')
  const [openInGoldPlan, setOpenInGoldPlan] = useState(false)
  const contentRef = useRef(null)
  const hasHome = themeMobx?.showTabs?.find(item => item.type === 'home')
  const [userInfo, setUserInfo] = useState({
    type: 'mobile',
    value: ''
  })
  const viewOrder = orderMobx.viewOrder
  const expressList = (viewOrder.expressList || []) as IExpressListInfo[]
  const expressNoList = (viewOrder.expressNoList || []) as IExpressListInfo[]
  const viewDetailList = orderMobx.viewDetailList
  const memberOrder = viewOrder.memberOrder
  const { eatType, statusShowName, contactInfo } = viewOrder
  const statusIndex = viewDetailList?.[0]?.currentStatusIndex || 1
  useEffect(() => {
    if (wxpayGoldPlanController.isOpen()) {
      setOpenInGoldPlan(true)
    }

    setHasMap(false)
    setContext('')
    if (expressList.length) {
      const expressInfo = expressList[0] as IExpressListInfo
      let _context = expressInfo.data?.[0]?.context
      if (_context) { // 快递信息切割手机号和电话号码
        const reg = /(1\d{10})|(0\d{2,3}-?\d{7,8})/g
        _context = _context.replace(reg, '<a class="context-phone" href="tel:$1$2">$1$2</a>')
        setContext(_context)
      }
      if (expressInfo.stateName === 'Delivering') {
        setHasMap(!!expressInfo?.trailUrl)
      }
    }
  }, [viewOrder])

  const getContent = useMemo(() => {
    let _contactInfo = {
      address: '',
      // latitude: '',
      // longitude: ''
    }
    try {
      _contactInfo = JSON.parse(contactInfo)
    } catch (error) {}
    return {
      address: _contactInfo.address || '',
      // latitude: _contactInfo.latitude || '',
      // longitude:  _contactInfo.longitude || '',
      name: viewOrder.contactName,
      mobile: viewOrder.contactMobile,
    }
  }, [contactInfo])

  const handleGo = (path) => {
    if (wxpayGoldPlanController.isOpen()) {
      wxpayGoldPlanController.goPath(path, orderMobx.viewOrder)
    } else {
      history.replace(path)
    }
  }

  const backToPage = () => {
    // 有可能是异步支付直接跳转过来的，返回需要回到mall
    if (history.getPrevState().includes('paypalreturn') || history.getPrevState().includes('checkout') || history.getPrevState() === '') {
      handleGo(`/${hasHome ? 'home' : 'mall'}`)
    } else {
      history.goBack()
    }
  }

  const trailUrl = useMemo(() => {
    const { isWeixinMiniProgram, isAliPayMiniProgram, inMiniApp } = getPlatform()
    let url = expressList?.[0]?.trailUrl
    if (url && (isWeixinMiniProgram || isAliPayMiniProgram || inMiniApp)) {
      // url = url.replace(/:\/\//, '/')
      // url = `${ENV.GWPWPROXY}/${url}`
      url = ''
    }
    return url
  }, [expressList])

  useMallRepositoryInit(true)

  return (
    <>
      <IonContent className='mall-pay-result-content' ref={contentRef}>
        {!openInGoldPlan ? (
          <div className='back-wrap' onClick={backToPage}><Icon name='BACK-12x' /></div>
        ) : null}
        {
          hasMap && <div className='express-info'><iframe src={trailUrl} width={document.body.offsetWidth} height='340' style={{ border: 'none' }}></iframe></div>
        }
        <div className='pay-result-wrapper'>
          <div className='pay-result-base'>
            {viewOrder.status === 'Success' ? (
              <>
                {statusIndex === 1 && memberOrder?.groupBuyId && memberOrder?.groupBuy?.status !== 'success' ? (
                  <div className='result-group-card-container'>
                    <GroupBuyStatus info={viewOrder} />
                  </div>
                ) : null}
                {(!hasMap && statusIndex === 1) || (statusIndex !== 1 && (!memberOrder?.groupBuyId || memberOrder?.groupBuy?.status === 'success')) ? (
                  <div className='make-info'>
                    <div className='make-result'>
                      {/* 拼团成功 */}
                      {memberOrder?.groupBuyId && memberOrder?.groupBuy?.status === 'success' && <p className='make-result-send'>{i18n.t('result.groupBuySucc')}</p>}
                      <p className='make-result-send'>{i18n.t(`result.expressStatusNew.${statusShowName[statusIndex]}Tip`)}</p>
                      <p className='make-result-desc' dangerouslySetInnerHTML={{ __html: context }}></p>
                    </div>
                    <div className='make-status'>
                      {
                        statusShowName?.map((item, index: number) => {
                          return (
                            <Fragment key={index}>
                              <>
                                {item !== 'order' && (
                                  <div className={`status-item ${statusIndex === index ? 'active' : ''}`}>
                                    <div>
                                      <i className={`iconfont ${iconMakeStatus[item]}`}></i>
                                      <p>{i18n.t(`result.expressStatusNew.${item}`)}</p>
                                    </div>
                                  </div>
                                )}
                              </>
                              {index !== statusShowName?.length - 1 && index !== 0 && <div className='split'></div>}
                            </Fragment>
                          )
                        })
                      }
                    </div>
                  </div>
                ) : null}
                {expressNoList.length ? (
                  // 快递单号和预计送达时间
                  <div className='content-wrapper dashed'>
                    <div className='content-title'>{i18n.t('result.address.expressDesc')}</div>
                    <div className='content-wrap'>
                      <div className='content'>{!!expressList?.[0]?.com && (i18n.t(`result.expressCom.${expressList?.[0]?.com}`) + ' ')}{expressNoList?.[0]?.expressNo}</div>
                      <div className='copy-btn' onClick={() => copyText(expressNoList?.[0]?.expressNo)}>{i18n.t('result.address.copy')}</div>
                    </div>
                    {expressList?.[0]?.arrivalTime && <div className='content-txt'>{i18n.t('result.deliverytime')}:{ddayjs(expressList?.[0]?.arrivalTime).format('YYYY-MM-DD')}</div>}
                  </div>
                ) : null}
                <div className='content-wrapper dashed'>
                  <div className='content-title'>{i18n.t('result.address.sendto')}</div>
                  <div className='content-wrap'>
                    <div className='content'>{getContent.address}</div>
                  </div>
                  <div className='content-txt'>{getContent.name} <a className='phone' href={`tel: ${getContent.mobile}`}>{getContent.mobile}</a></div>
                </div>
              </>
            ) : (
              // 支付失败
              <div className='make-info'>
                <div className='make-result'>
                  <p className='make-result-send'>{i18n.t(reason[viewOrder.status])}</p>
                  <p className='make-result-desc'>{i18n.t(tips[viewOrder.status])}</p>
                </div>
              </div>
            )}
          </div>
          <div className='pay-result-detail'>
            {
              viewOrder.remark ? (
                <div className='content-wrapper dashed'>
                  <div className='remark'>
                    {i18n.t('common.note')}: {viewOrder.remark}
                  </div>
                </div>
              ) : null
            }
            <div className='content-wrapper dashed'>
              <div className='content-title'>{i18n.t('result.productInfo')}</div>
              <div className='product-list-wrap'>
                {
                  viewDetailList.map((item: any, index: number) => {
                    return (
                      <div className='product-item-wrap' key={`${item.id}_${index}`}>
                        <ProductImage color={!item.pic ? item.productNo : ''} width={64} imgSrc={item.pic} />
                        <div className='product-content-wrapper'>
                          <div className='product-item' key={item.productNo}>
                            <div className='name'>
                              <p className='name-txt'>{item.name} {item.cardNo ? item.cardNo : ''}</p>
                              {!!item.optionHtml && <p dangerouslySetInnerHTML={{ __html: item.optionHtml }} />}
                              {!!item.remark && (<p className='note'>{i18n.t('common.note')}: {item.remark}</p>)}
                            </div>
                            <div className='amount'>
                              <div className='price'>{toPrice(item.totalPrice)}</div>
                              <div className='count'>x{item.cnt}</div>
                            </div>
                          </div>
                          {
                            (item.cardType === 'giftcard' || item.cardType === 'card') &&
                              <div className='product-groups'><span className='product-coupon'>{ordersController.getCardInfo(item)}</span></div>
                          }
                          <div className='product-groups'>
                            {
                              item.productGroups?.map(group => (
                                <div key={group.no} className='product-group'>
                                  {
                                    group?.productGroupDetails.map(product => (
                                      <div key={product.pk} className='product-group-product'>
                                        <div className='name'>
                                          <p>{product.name}</p>
                                          {!!product.optionHtml && <p dangerouslySetInnerHTML={{ __html: product.optionHtml }} />}
                                          {!!product.remark && (<p className='note'>{i18n.t('common.note')}: {product.remark}</p>)}
                                        </div>
                                        <div className='count'>x{product.cnt}</div>
                                      </div>
                                    ))
                                  }
                                </div>
                              ))
                            }
                          </div>
                          {
                            item.offItems?.map((v: any, index: number) => {
                              return (
                                <div className='discount-item space-between' key={index}>
                                  <span className='name'>{v.offType === 'memberPrice' ? i18n.t('result.member_price') : v.offTip}</span>
                                  <span className='price'>- {toPrice(v.off)}</span>
                                </div>
                              )
                            })
                          }
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
            <div className='hide-detail content-wrapper'>
              {
                viewOrder.offItems.map((offItem, index) => <DetailItem key={index} title={offItem.offTip} content={toPrice(-offItem.off)} />)
              }
              {
                !!viewOrder.discountIntegralMoneyPrice && <DetailItem title={i18n.t('result.integralMoney')} content={toPrice(-orderMobx.viewOrder.discountIntegralMoneyPrice)} />
              }
              {
                !!viewOrder.orderPlanOffItem && <DetailItem title={orderMobx.viewOrder.orderPlanOffItem.tagId ? orderMobx.viewOrder.orderPlanOffItem.offTip : i18n.t('result.managerDiscount')} content={toPrice(-orderMobx.viewOrder.orderPlanOffItem.off)} />
              }
              <DetailItem title={i18n.t('result.goodsPrice')} content={toPrice(viewOrder.itemPrice || 0)} />
              {
                !!viewOrder.expressPrice &&
                  <DetailItem title={i18n.t('result.expressPriceMall')} content={toPrice(viewOrder.expressPrice || 0)} />
              }
              <DetailItem title={i18n.t('result.allDiscount')} content={toPrice(-viewOrder.totalDiscountPrice || 0)} />
              {
                bo === 'us' &&
                  <DetailItem title={i18n.t('result.subTotal')} content={toPrice(viewOrder.itemTotalPrice || 0)} />
              }
              {
                viewOrder.discountFloorPrice > 0 &&
                  <DetailItem title={i18n.t('result.floor')} content={toPrice(-viewOrder.discountFloorPrice || 0)} />
              }
              {
                viewOrder.serviceCharge > 0 &&
                  <DetailItem
                    title={(
                      <Fragment key='serviceCharge'>
                        <span>{viewOrder.serviceChargeGratuityName}</span>
                        <i className='iconfont icon-question'></i>
                      </Fragment>
                    )}
                    content={toPrice(viewOrder.serviceCharge || 0)}
                  />
              }
              {
                bo === 'us' && viewOrder.tax === 0 && !viewOrder.taxDetail.length &&
                  <DetailItem title={i18n.t('result.tax')} content={toPrice(viewOrder.tax || 0)} />
              }
              {
                (bo === 'us' && viewOrder.tax > 0) && viewOrder.taxDetail.map((taxItem, index) => {
                  return <DetailItem key={index} title={`${taxItem.taxCategoryId === -1 ? i18n.t('cart.tax') : taxItem.name || i18n.t('cart.tax')}(${!taxItem.isTaxFree ? taxItem.rate + '%' : 'exempt'})`} content={toPrice(-taxItem.amount)} />
                })
              }
              {
                viewOrder.showTax > 0 && bo === 'us' &&
                  <DetailItem title={i18n.t('cart.haveTax')} content={toPrice(viewOrder.showTax)} />
              }
              <DetailItem title={i18n.t('result.total')} content={toPrice(viewOrder.totalPriceExcludeTip || 0)} />
              <div className='dashed'></div>
              {
                viewOrder.tip > 0 &&
                  <DetailItem title={i18n.t('result.tip')} content={toPrice(viewOrder.tip)} />
              }
              <DetailItem title={i18n.t('result.alltotal')} content={toPrice(Number(viewOrder.totalPrice))} />
              {
                viewOrder.paymentList?.map((pay: any, index: number) => {
                  const { name, cardNo, amountPaid } = payMobx.getPaymentDisplay(pay)
                  return (
                    <Fragment key={pay.paymentId}>
                      {viewOrder.paymentList.length > 1 && <DetailItem title={i18n.t('result.payment')} />}
                      <DetailItem title={viewOrder.paymentList.length === 1 ? i18n.t('result.payment') : name} content={viewOrder.paymentList.length === 1 ? name : toPrice(amountPaid)} />
                      <DetailItem title={i18n.t('result.cardNumber')} content={`**** ${cardNo?.substring(cardNo.length - 4, cardNo.length)}`} style={{ display: !cardNo ? 'none' : 'flex' }} />
                    </Fragment>
                  )
                })
              }
              {/* 退款金额 */}
              {
                !!viewOrder.ordersRefundList?.length &&
                  <DetailItem dashed title={i18n.t('result.refund')} content={`-${toPrice(sumBy(viewOrder.ordersRefundList, (n) => n.refundFee))}`} />
              }
              <div className='dashed'></div>
              <DetailItem title={i18n.t('result.orderTime')} content={toDateTime(viewOrder.addTime)} />
              <DetailItem title={i18n.t('result.nono2')} content={viewOrder.ordersId} />
              <div className='dashed'></div>
            </div>
            <div className='content-wrapper shop-info'>
              <div className='content-wrap'>
                <div className='content bold'>{repositoryMobx.info.repositoryName}</div>
              </div>
              <div className='content-txt' style={{ marginBottom: 6 }}>{repositoryMobx.info.senderAddress}</div>
              <div className='content-txt'><a className='phone' href={`tel: ${repositoryMobx.info.tel}`}>{repositoryMobx.info.tel}</a></div>
              <div className='store-phone-wrapper'>
                <div>
                  <a href={`tel: ${repositoryMobx.info.tel}`}>
                    <i className='iconfont icon-store-tel'></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </IonContent>
    </>
  )
}

export default observer(Result)
